function waitForWidget(selector, timeout = 10000) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(selector);
    if (existing) return resolve(existing);

    const observer = new MutationObserver((mutations, obs) => {
      const el = document.querySelector(selector);
      if (el) {
        obs.disconnect();
        resolve(el);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Widget not found within ${timeout}ms`));
    }, timeout);
  });
}

function extractWidgetData(widget) {
  const data = {
    widgetId: widget.getAttribute('widget') || null,
    offerId: widget.getAttribute('offer') || null,
    triggerProductId: widget.getAttribute('lb-trigger-product-id') || null,
    products: [],
  };

  const cards = widget.querySelectorAll('lb-upsell-long-card[product-card]');

  cards.forEach((card) => {
    const productId = card.getAttribute('lb-product-id');
    const variantId = card.getAttribute('lb-variant-id');
    const productHandle = card.getAttribute('lb-product-handle');

    const titleEl = card.querySelector('.lb-card-title');
    const priceEl = card.querySelector('[lb-price]');
    const imgEl = card.querySelector('.lb-card-img');

    const variantOptions = [];
    card.querySelectorAll('.lb-variant-picker option').forEach((opt) => {
      variantOptions.push({
        variantId: opt.value,
        label: opt.textContent.trim(),
      });
    });

    data.products.push({
      productId,
      variantId,
      productHandle,
      title: titleEl?.textContent.trim() || null,
      price: priceEl?.getAttribute('lb-price') || null,
      priceRaw: priceEl?.getAttribute('lb-default-price') || null,
      imageAlt: imgEl?.getAttribute('alt') || null,
      imageSrc: imgEl?.getAttribute('src') || null,
      variants: variantOptions,
    });
  });

  return data;
}

function publishLinkClick(clickData) {
  window.ShopifyAnalytics = window.ShopifyAnalytics || {};
  window.Shopify?.analytics?.publish('page-click', { clickData });
}

function bindCardClickEvents(widget, widgetData) {
  const cards = widget.querySelectorAll('lb-upsell-long-card[product-card]');

  if (!cards.length) {
    setTimeout(() => bindCardClickEvents(widget, widgetData), 500);
    return;
  }

  let bound = 0;
  cards.forEach((card) => {
    const titleEl = card.querySelector('.lb-card-title');
    const imgEl = card.querySelector('.lb-card-img');

    [titleEl, imgEl].forEach((el) => {
      if (el) {
        el.addEventListener('click', () => {
          sessionStorage.setItem(
            'click-data',
            JSON.stringify({
              linkTitle: 'completeLookProductClick',
              linkText: 'completeLookProductClick',
              moduleName: 'pdp:aplus:completeLook',
              targetURL: null,
              locURL: window.location.pathname,
              imgTitleClick: false,
            }),
          );
        });
        bound++;
      }
    });
  });

  if (bound === 0) {
    setTimeout(() => bindCardClickEvents(widget, widgetData), 500);
    return;
  }
}

function bindAddToCartEvents(widget, widgetData) {
  const cards = widget.querySelectorAll('lb-upsell-long-card[product-card]');

  if (!cards.length) {
    setTimeout(() => bindAddToCartEvents(widget, widgetData), 500);
    return;
  }

  let bound = 0;
  cards.forEach((card) => {
    const addBtn = card.querySelector('.lb-button[role="button"]');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        document.cookie = 'atc-source=completeLookATC; path=/; max-age=10';
      });
      bound++;
    }
  });

  if (bound === 0) {
    setTimeout(() => bindAddToCartEvents(widget, widgetData), 500);
    return;
  }
}

function bindArrowEvents(widget, widgetData) {
  const prevArrow = widget.querySelector('.lb-carousel-left-svg');
  const nextArrow = widget.querySelector('.lb-carousel-right-svg');

  if (!prevArrow || !nextArrow) {
    setTimeout(() => bindArrowEvents(widget, widgetData), 500);
    return;
  }

  prevArrow.addEventListener('click', () => {
    publishLinkClick({
      pageName: document.title,
      pageType: document.documentElement.dataset.pageType || 'product',
      moduleName: 'pdp:aplus:completeLook',
      locURL: window.location.pathname,
      linkTitle: 'completeLookPrev',
      linkText: 'completeLookPrev',
      targetURL: null,
      filters: null,
      searchTerm: null,
      widgetId: widgetData.widgetId,
      offerId: widgetData.offerId,
      triggerProductId: widgetData.triggerProductId,
    });
  });

  nextArrow.addEventListener('click', () => {
    publishLinkClick({
      pageName: document.title,
      pageType: document.documentElement.dataset.pageType || 'product',
      moduleName: 'pdp:aplus:completeLook',
      locURL: window.location.pathname,
      linkTitle: 'completeLookNext',
      linkText: 'completeLookNext',
      targetURL: null,
      filters: null,
      searchTerm: null,
      widgetId: widgetData.widgetId,
      offerId: widgetData.offerId,
      triggerProductId: widgetData.triggerProductId,
    });
  });
}

waitForWidget('lb-upsell-widget')
  .then((widget) => {
    const widgetData = extractWidgetData(widget);

    bindCardClickEvents(widget, widgetData);
    bindAddToCartEvents(widget, widgetData);
    bindArrowEvents(widget, widgetData);
  })
  .catch((err) => console.error(err));

function waitForReviews(selector, timeout = 15000) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(selector);
    if (existing) return resolve(existing);

    const observer = new MutationObserver((_, obs) => {
      const el = document.querySelector(selector);
      if (el) {
        obs.disconnect();
        resolve(el);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      reject(new Error('[Yotpo Analytics] Widget not found within timeout'));
    }, timeout);
  });
}

function retryUntilFound(widget, selector, callback, interval = 500, maxAttempts = 20) {
  let attempts = 0;
  function attempt() {
    const els = widget.querySelectorAll(selector);
    if (els.length) {
      callback(els);
      return;
    }
    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(attempt, interval);
    } else {
      console.warn(`[Yotpo Analytics] "${selector}" not found after ${maxAttempts} attempts`);
    }
  }
  attempt();
}

function bindWriteReviewEvent(widget) {
  retryUntilFound(widget, '#yotpo-main-widget-btn', (els) => {
    els[0].addEventListener('click', () => {
      publishLinkClick({
        pageName: document.title,
        pageType: 'product',
        moduleName: 'pdp:aplus:reviews',
        locURL: window.location.pathname,
        linkTitle: 'writeReviewClick',
        linkText: 'writeReviewClick',
        targetURL: null,
        filters: null,
        searchTerm: null,
      });
    });
  });
}

function bindReviewSubmitEvent() {
  const observer = new MutationObserver(() => {
    const submitBtn = document.querySelector('.yotpo-new-review-submit');
    if (submitBtn && !submitBtn.dataset.lbAnalyticsBound) {
      submitBtn.dataset.lbAnalyticsBound = 'true';
      submitBtn.addEventListener('click', () => {
        publishLinkClick({
          pageName: document.title,
          pageType: document.documentElement.dataset.pageType || 'product',
          moduleName: 'pdp:aplus:reviews',
          locURL: window.location.pathname,
          linkTitle: 'reviewSubmit',
          linkText: 'reviewSubmit',
          targetURL: null,
          filters: null,
          searchTerm: null,
        });
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function waitForElement(selector, timeout = 15000) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(selector);
    if (existing) return resolve(existing);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      reject(new Error(`[Yotpo Analytics] "${selector}" not found within timeout`));
    }, timeout);
  });
}

function bindYotpoDropdownEvents() {
  function observeDropdown(container, getLabel) {
    if (!container) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'aria-selected' &&
          mutation.target.getAttribute('aria-selected') === 'true'
        ) {
          const val = getLabel(mutation.target);
          publishLinkClick({
            pageName: document.title,
            pageType: 'product',
            moduleName: 'pdp:aplus:reviews',
            locURL: window.location.pathname,
            linkTitle: 'reviewFilterChange',
            linkText: 'reviewFilterChange',
            targetURL: null,
            filters: val,
            searchTerm: null,
          });
        }
      });
    });

    observer.observe(container, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
  }
  Promise.all([waitForElement('.yotpo-score-filter-container'), waitForElement('.yotpo-sorting-filter-container')])
    .then(([ratingContainer, sortContainer]) => {
      observeDropdown(ratingContainer, (el) => {
        const val = el.querySelector('.formated-value')?.textContent.trim();
        return `reviewRatingFilter:${val || ''}`;
      });

      observeDropdown(sortContainer, (el) => {
        const val = el.querySelector('.yotpo-dropdown-option-label')?.textContent.trim();
        return `reviewSortFilter:${val || ''}`;
      });
    })
    .catch((err) => console.warn(err.message));
}

function bindPaginationEvents(widget) {
  function bindButtons() {
    const buttons = widget.querySelectorAll(
      '.yotpo-reviews-pagination-item:not([data-lb-bound])', // ← add this back
    );
    buttons.forEach((btn) => {
      btn.dataset.lbBound = 'true';
      btn.addEventListener('click', () => {
        publishLinkClick({
          pageName: document.title,
          pageType: 'product',
          moduleName: 'pdp:aplus:reviews',
          locURL: window.location.pathname,
          linkTitle: 'reviewLoadMore',
          linkText: 'reviewLoadMore',
          targetURL: null,
          filters: null,
          searchTerm: null,
        });
      });
    });
  }
  bindButtons();
  const observer = new MutationObserver(bindButtons);
  observer.observe(widget, { childList: true, subtree: true });
}

function bindHelpfulEvents(widget) {
  function bindVoteButtons() {
    const thumbUpBtns = widget.querySelectorAll('button[aria-label="This review was helpful"]:not([data-lb-bound])');
    thumbUpBtns.forEach((btn) => {
      btn.dataset.lbBound = 'true';
      btn.addEventListener('click', () => {
        const reviewEl = btn.closest('[data-id]');
        const reviewId = reviewEl ? reviewEl.getAttribute('data-id') : null;
        publishLinkClick({
          pageName: document.title,
          pageType: 'product',
          moduleName: 'pdp:aplus:reviews',
          locURL: window.location.pathname,
          linkTitle: 'reviewHelpful',
          linkText: 'reviewHelpful',
          targetURL: null,
          filters: null,
          searchTerm: null,
          reviewId,
        });
      });
    });
  }

  bindVoteButtons();
  const observer = new MutationObserver(bindVoteButtons);
  observer.observe(widget, { childList: true, subtree: true });
}

function bindPhotoLightboxEvents(widget) {
  function bindPhotoTriggers() {
    const thumbnailButtons = widget.querySelectorAll(
      '.yotpo-reviews-main-widget .yotpo-single-thumbnail:not([data-lb-bound])',
    );

    thumbnailButtons.forEach((btn) => {
      btn.dataset.lbBound = 'true';
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        publishLinkClick({
          pageName: document.title,
          pageType: 'product',
          moduleName: 'pdp:aplus:reviews',
          locURL: window.location.pathname,
          linkTitle: 'reviewPhotoView',
          linkText: 'reviewPhotoView',
          targetURL: null,
          filters: null,
          searchTerm: null,
        });
      });
    });
  }

  bindPhotoTriggers();
  const observer = new MutationObserver(bindPhotoTriggers);
  observer.observe(widget, { childList: true, subtree: true });
}

waitForReviews('#yotpo-reviews-main-widget')
  .then((widget) => {
    bindWriteReviewEvent(widget);
    bindReviewSubmitEvent(widget);
    bindYotpoDropdownEvents();
    bindPaginationEvents(widget);
    bindHelpfulEvents(widget);
    bindPhotoLightboxEvents(widget);
  })
  .catch((err) => console.warn(err.message));
